import { Link } from "react-router-dom";
import FeatureContainer from "../../../Layout/Containers/FeatureContainer";
import { Button, CardBody, CardHeader } from "reactstrap";
import { isAdmin } from "../../../Utils/externalFunctions";
import CutiModal from "../components/CutiModal";
import {
  FEATURE_FUNCTION_SELECTION,
  PERMISSIONS,
} from "../../../Constant/FeatureSelection";
import RoleContext from "../../../Context/RoleContext";
import { useContext } from "react";

const ACTIVE_COMPONENT = {
  daftarcuti: null,
  rekapcuti: "rekap",
  dalamprosescuti: "proses",
};

const CutiContain = ({
  selectedComponent,
  title,
  subtitle,
  refreshDaftarCuti,
  children,
}) => {
  const { checkPermission } = useContext(RoleContext);

  const createButton = checkPermission(PERMISSIONS.ADD_CUTI) && (
    <CutiModal create resetState={refreshDaftarCuti} />
  );

  return (
    <FeatureContainer
      title={title}
      subtitle={subtitle}
      createButton={createButton}
    >
      <CardHeader className={"pt-0"}>
        <CutiNavbar activeComponent={selectedComponent} />
      </CardHeader>
      <CardBody>{children}</CardBody>
    </FeatureContainer>
  );
};

const CutiNavbar = ({ activeComponent }) => {
  const { checkPermission } = useContext(RoleContext);
  return (
    <div className="row row-cols-sm-3 row-cols-xl-5 text-center justify-content-center ">
      {checkPermission(PERMISSIONS.VIEW_CUTI) && (
        <Link
          className="p-0 d-flex align-items-stretch"
          to={`${process.env.PUBLIC_URL}/cuti`}
        >
          <Button
            className="w-100"
            active={activeComponent === ACTIVE_COMPONENT.daftarcuti}
            // style={{
            //   "border-top-left-radius": "6px",
            //   "border-bottom-left-radius": "6px",
            // }}
          >
            Cuti
          </Button>
        </Link>
      )}
      {checkPermission(PERMISSIONS.VIEW_REKAP_CUTI) && (
        <Link
          className="p-0 d-flex align-items-stretch"
          to={`${process.env.PUBLIC_URL}/cuti?type=rekap`}
        >
          <Button
            className="w-100"
            active={activeComponent === ACTIVE_COMPONENT.rekapcuti}
          >
            Rekap Cuti
          </Button>
        </Link>
      )}
      {checkPermission(PERMISSIONS.VIEW_DALAM_PROSES_CUTI) && (<Link
        className="p-0 d-flex align-items-stretch"
        to={`${process.env.PUBLIC_URL}/cuti?type=proses`}
      >
        <Button
          className="w-100"
          active={activeComponent === ACTIVE_COMPONENT.dalamprosescuti}
        >
          Dalam Proses Cuti
        </Button>
      </Link>)}
    </div>
  );
};

export default CutiContain;
